import { Link, useNavigate } from "react-router-dom";
import { Barcode } from "lucide-react";

export default function LabelBreadcrumb({ title, link, id }) {
  const navigate = useNavigate();
  return (
    <div className="bg-white  pt-6 px-4 md:px-8">
      {/* Breadcrumb */}
      <nav className="text-sm text-gray-600 mb-2" aria-label="Breadcrumb">
        <ol className="list-reset flex">
          <li>
            <Link to="/accueil/certificats" className="hover:underline">
              Accueil
            </Link>
          </li>
          <li>
            <span className="mx-2">›</span>
          </li>
          {link ? (
            <li>
              <Link to={link} className="hover:underline">
                {title}
              </Link>
            </li>
          ) : (
            <li className="text-gray-800 font-medium">{title}</li>
          )}

          {id && (
            <>
              <li>
                <span className="mx-2">›</span>
              </li>
              <li className="text-gray-800 font-medium">{id}</li>
            </>
          )}
        </ol>
      </nav>

      {id && (
        <div className="flex items-center space-x-2">
          <Barcode className="md:w-8 w-4 h-4 md:h-8 text-gray-700" />
          <h1 className=" text-[0.9rem] md:text-2xl font-semibold text-gray-900">
            {" "}
            {id}
          </h1>
        </div>
      )}

      {/* Back link */}
      <div className="mt-4">
        <button
          onClick={() => navigate(-1)}
          className="inline-block text-sm text-blue-700 hover:text-blue-900 border border-blue-700 px-3 py-1 rounded"
        >
          &larr; Retour
        </button>
      </div>
    </div>
  );
}
